<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-plus"
      @click="openEditFunctionSwitchDialog(true)"
      >新增配置</el-button
    >
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-minus"
      :disabled="this.selectionList.length == 0"
      @click="deleteManyFunctionSwitch()"
      >批量删除</el-button
    >
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-document-copy"
      :disabled="this.selectionList.length == 0"
      @click="copyToClipboard()"
      >复制到剪贴板</el-button
    >
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-document-add"
      @click="addFromClipboard2()"
      >从剪贴板添加</el-button
    >

    <el-table
      :data="functionSwitchList"
      border
      size="small"
      height="700px"
      style="width: 1479px"
      :row-class-name="tableRowClassName"
      @select="select"
      @select-all="select"
      @sort-change="sortByCreatedAt"
    >
      <el-table-column type="selection" width="48"> </el-table-column>
      <el-table-column label="启用配置" align="center" width="80">
        <template slot-scope="scope">
          <span
            v-if="scope.row.isAvailable"
            class="switch-status-tag switch-status-tag-on"
            >是</span
          >
          <span v-else class="switch-status-tag switch-status-tag-off">否</span>
        </template>
      </el-table-column>

      <el-table-column label="配置生效时间" align="center" width="300">
        <template slot-scope="scope">
          <span>{{ cycleTypeEntries[scope.row.cycleType] }}</span>
          <span v-if="scope.row.cycleType == 1"
            >（{{
              $util.ms2ymdhm(new Date(scope.row.cycleStart).getTime())
            }}到{{
              $util.ms2ymdhm(new Date(scope.row.cycleEnd).getTime())
            }}
            ）</span
          >
          <span v-if="scope.row.cycleType == 2">
            （每天{{ formatSimpleTime(parseInt(scope.row.cycleStart / 60)) }}:{{
              formatSimpleTime(parseInt(scope.row.cycleStart % 60))
            }}到每天{{ formatSimpleTime(parseInt(scope.row.cycleEnd / 60)) }}:{{
              formatSimpleTime(parseInt(scope.row.cycleEnd % 60))
            }}
            ）
          </span>
          <span v-if="scope.row.cycleType == 3">
            （每周{{
              $util.number2ZhWeek(
                parseInt(Number(scope.row.cycleStart) / (24 * 60)) + 1
              )
            }}{{
              formatSimpleTime(
                parseInt((Number(scope.row.cycleStart) % (24 * 60)) / 60)
              )
            }}:{{
              formatSimpleTime(
                parseInt((Number(scope.row.cycleStart) % (24 * 60)) % 60)
              )
            }}到每周{{
              $util.number2ZhWeek(
                parseInt(Number(scope.row.cycleEnd) / (24 * 60)) + 1
              )
            }}{{
              formatSimpleTime(
                parseInt((Number(scope.row.cycleEnd) % (24 * 60)) / 60)
              )
            }}:{{
              formatSimpleTime(
                parseInt((Number(scope.row.cycleEnd) % (24 * 60)) % 60)
              )
            }}
            ）
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="minVersion"
        label="配置生效版本"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.minVersion }}~{{ scope.row.maxVersion }}
        </template>
      </el-table-column>
      <el-table-column
        prop="channelName"
        label="配置生效渠道"
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          <span
            style="color: red"
            v-if="scope.row.channelName.trim().length == 0"
            >{{ "<未知渠道>" }}</span
          >
          <span v-else>{{ scope.row.channelName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="key"
        label="Key"
        align="center"
        width="130"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="param"
        label="自定义参数"
        align="center"
        width="100"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="minLevel"
        label="得通过第几关"
        align="center"
        width="100"
      >
      </el-table-column>

      <el-table-column
        label="满足所有条件后的开关状态"
        align="center"
        width="110"
      >
        <template slot="header">
          <span>满足所有条件后的开关状态</span>
          <div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                若有一项条件不满足，则客户端会使用自行设置的默认状态
              </div>
              <span
                ><i class="el-icon-question" style="font-size: 1.2em"></i
              ></span>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <span
            v-if="scope.row.status == 0"
            class="switch-status-tag switch-status-tag-off"
            >关</span
          >
          <span
            v-if="scope.row.status == 1"
            class="switch-status-tag switch-status-tag-on"
            >开</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注"
        align="center"
        width="200"
      ></el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <span
            class="link-button"
            @click="deleteFunctionSwitch(scope.row.id, scope.row)"
            >删除</span
          >
          <span
            class="link-button"
            @click="openEditFunctionSwitchDialog(false, scope.row)"
            >修改</span
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑对话框 -->
    <EditFunctionSwitchDialog
      v-if="shouldEditFunctionSwitchDialogVisible"
      @close="onEditFunctionSwitchDialogClosed()"
      :value="valueForEditFunctionSwitchDialog"
    ></EditFunctionSwitchDialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

import EditFunctionSwitchDialog from "./EditFunctionSwitchDialog";

export default {
  data() {
    return {
      shouldEditFunctionSwitchDialogVisible: false, // 编辑对话框是否应该显示出来
      valueForEditFunctionSwitchDialog: null, // 要传递给编辑对话框的数据
      functionSwitchList: [], // 列表里展示的数据
      selectionList: [],
      defaultFunctionSwitchList: "", // 默认的列表数据
      cycleTypeEntries: {
        0: "永久",
        1: "现实时间",
        2: "24小时内",
        3: "七天内",
      },
    };
  },

  created() {
    // 拉取集合
    this.loadFunctionSwitchList();
  },

  components: {
    EditFunctionSwitchDialog,
  },

  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.isRepeat) {
        return "warning-row";
      }
      return "";
    },
    select(selection, row) {
      this.selectionList = selection;
    },
    sortByCreatedAt(obj) {
      if (!obj.order) {
        this.functionSwitchList = JSON.parse(this.defaultFunctionSwitchList);
        return;
      }

      if (obj.order == "ascending") {
        this.functionSwitchList.sort((x, y) => {
          if (x.createdAt.length == y.createdAt.length) {
            return x.createdAt.localeCompare(y.createdAt);
          } else {
            return x.createdAt.length - y.createdAt.length;
          }
        });
      }
      if (obj.order == "descending") {
        this.functionSwitchList.sort((x, y) => {
          if (x.createdAt.length == y.createdAt.length) {
            return y.createdAt.localeCompare(x.createdAt);
          } else {
            return y.createdAt.length - x.createdAt.length;
          }
        });
      }
    },
    ms2ymdhmss(ts) {
      return util.ms2datetime(ts);
    },
    /**
     * 查询集合
     */
    async loadFunctionSwitchList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getFunctionSwitches`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.switches || [];

      // 排序（按id倒序排列）
      listInResponse.sort((x, y) => {
        let tmp = y.key.localeCompare(x.key);
        if (tmp == 0) {
          if (x.id.length == y.id.length) {
            return x.id.localeCompare(y.id);
          } else {
            return x.id.length - y.id.length;
          }
        }
        return tmp;
      });

      const entries = new Map();

      for (let i = 0; i < listInResponse.length; i++) {
        let ok = entries.has(
          listInResponse[i].key + "-" + listInResponse[i].channelName
        );
        if (ok) {
          listInResponse[i].isRepeat = true;
        } else {
          entries.set(
            listInResponse[i].key + "-" + listInResponse[i].channelName,
            true
          );
        }
      }
      this.defaultFunctionSwitchList = JSON.stringify(listInResponse);
      this.functionSwitchList = listInResponse;
    },

    /**
     * 删除
     * @param {*} id
     * @param {*} entry
     */
    async deleteManyFunctionSwitch() {
      try {
        // 弹确认框
        await this.$confirm(`确认批量删除所选择的功能开关集合？`);
        let delList = JSON.parse(JSON.stringify(this.selectionList));
        for (let i = 0; i < delList.length; i++) {
          await this.delete(delList[i].id, delList[i]);
        }
      } catch (e) {}
    },

    /**
     * 删除
     * @param {*} id
     * @param {*} entry
     */
    async deleteFunctionSwitch(id, entry) {
      try {
        // 弹确认框
        await this.$confirm(
          `确认删除生效渠道为“${entry.channelName}”、Key为“${entry.key}”的开关配置？`
        );
        await this.delete(id, entry);
      } catch (e) {}
    },

    async delete(id, entry) {
      try {
        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/deleteFunctionSwitch`,
            {
              id: id,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.functionSwitchList.length; i++) {
          if (this.functionSwitchList[i].id == id) {
            this.functionSwitchList.splice(i, 1);
            break;
          }
        }

        for (let i = 0; i < this.selectionList.length; i++) {
          if (this.selectionList[i].id == id) {
            this.selectionList.splice(i, 1);
            break;
          }
        }
      } catch (e) {}
    },

    /**
     * 打开编辑对话框
     */
    async openEditFunctionSwitchDialog(isCreate, oldData) {
      this.shouldEditFunctionSwitchDialogVisible = true;
      this.valueForEditFunctionSwitchDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * 编辑对话框关闭了
     */
    async onEditFunctionSwitchDialogClosed() {
      this.shouldEditFunctionSwitchDialogVisible = false;

      // 重新拉取集合
      return this.loadFunctionSwitchList();
    },
    /**
     * 复制到剪贴板
     */
    async copyToClipboard() {
      if (this.selectionList.length == 0) {
        this.$message({
          message: "未选中任何可复制内容",
          type: "warning",
        });
      }
      try {
        await navigator.clipboard.writeText(
          JSON.stringify({ copyFunctionList: this.selectionList })
        );
        this.$message({
          message: "复制成功",
          type: "success",
        });
      } catch (err) {
        this.$message.error("复制失败： " + JSON.stringify(err));
      }
    },

    async addFromClipboard2() {
      let result = await navigator.permissions.query({
        name: "clipboard-read",
      });

      if (result.state === "granted" || result.state === "prompt") {
        // 可以使用权限
        // 进行clipboard的操作
        let text = await navigator.clipboard.readText();

        let obj = JSON.parse(text).copyFunctionList;
        if (obj) {
          for (let i = 0; i < obj.length; i++) {
            let item = obj[i];
            await this.addFunction(item);
          }

          this.selectionList = [];
          this.loadFunctionSwitchList();
        }
      } else if (result.state === "denied") {
        alert("已禁止访问粘贴板，请手动开启权限");
      }
    },

    /**
     * 新增
     */
    async addFunction(entry) {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/addFunctionSwitch`,
          {
            switch: entry,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      this.$message({
        message: "添加成功",
        type: "success",
      });
    },
    formatSimpleTime(val) {
      let v = parseInt(val);
      if (v < 10) {
        return "0" + v;
      }
      return v;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table .warning-row {
  background: #e7e7e7;
}

.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}

.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}

.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}

::v-deep .el-table__row td {
  padding: 3px 0;
}

::v-deep .el-table .cell {
  line-height: 18px;
}

.link-button {
  padding-left: 10px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}
</style>